import React, { useState, useRef, useEffect,useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LedgerEntires } from '../store/slices/bankbook';
import { updateOpeningBalanceAll, GetSpecialOpeningBalance } from '../store/slices/ledger';
import Table from '../common/Table';
import { toast } from 'react-hot-toast';
import {API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import Loader from '../common/Loader';
import AdminLayout from './AdminLayout';
import { FaFileExcel } from "react-icons/fa";
import {excelledgerEntriesDownload } from "../common/ExcelDownload"

const LedgerDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const { ledgerid } = useParams();

  const user = JSON.parse(localStorage.getItem('user'));
  const profile_id = user?.data?.profile_id;

  // console.log("ledgerid",ledgerid)
  const [isLoading, setIsLoading] = useState(false);
  const [ledgerEntires, setLedgerEntires] = useState([]);
  const [ledgerDetails, setLedgerDetails] = useState({});
  const [closingBalance, setClosingBalance] = useState('');
  const [closingBalanceType, setClosingBalanceType] = useState('');
  // const [pdfData, setPdfData] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [searchQuery, setSearchQuery] = useState('');


  const [data, setData] = useState({
    profile_id: profile_id,
    ledger_id: ledgerid,
    opening_balance: "",
    opening_date: "",
    dr_cr: ""
  });

  const [showDateFilters, setShowDateFilters] = useState(true);

  const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem("selectedFinancialYear");

    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes("-")) {
      [startYear, endYear] = savedFinancialYear.split("-");
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear; // Example: 2025 (for 2024-2025)
    }

    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem("savedFromDate") || `${startYear}-04-01`,
      toDate: localStorage.getItem("savedToDate") || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };

  const {
    fromDate: initialFromDate,
    toDate: initialToDate,
    minDate,
    maxDate,
    financialYear: initialFinancialYear,
  } = loadSavedDates();
 
 const [fromDate, setFromDate] = useState(initialFromDate);
 const [toDate, setToDate] = useState(initialToDate);
 const [financialYear, setFinancialYear] = useState(initialFinancialYear);
 
 
 useEffect(() => {
   if (financialYear) {
     localStorage.setItem('selectedFinancialYear', financialYear);
   }
 
   const [startYear, endYear] = financialYear.split('-');


   // Ensure dates remain within the financial year range
   const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
   const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;


   setFromDate(savedFromDate);
   setToDate(savedToDate);
 
   if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
   if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
 }, [financialYear]);
 


  const [item, setItem] = useState({
    ledger_id: ledgerid,
    profile_id: profile_id,
    from_date: fromDate,
    to_date: toDate,
  });

    const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
    const [selectAll, setSelectAll] = useState(false);

  const [columns, setcolumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Type', field: 'type' },
    { header: 'Description', field: 'description', isMultiline: true },
    { header: 'Date', field: 'ledger_date' },
    { header: 'Dr', field: 'dr', isDrCr: true, isDr: true },
    { header: 'Cr', field: 'cr', isDrCr: true, isDr: false },
    { header: 'Closing Balance', field: 'balance' },
  ]);


  React.useEffect(() => {
    handleLedgerClick(null, ledgerid); // Pass null for event, pass ledgerid directly
  }, [dispatch, ledgerid]);

  const handleLedgerClick = async (e) => {
    if (e) e.preventDefault();

    const newItem = {
      ...item,
      ledger_id: ledgerid,
      from_date: fromDate,
      to_date: toDate,
    };
    console.log("newItem", newItem);
    setItem(newItem);

    setIsLoading(true);

    try {
      // Always fetch ledger entries first
      const entriesResponse = await dispatch(LedgerEntires(newItem)).unwrap();
      const entriesData = entriesResponse?.data || {};

      setLedgerEntires(entriesData?.entries || []);
      setClosingBalance(entriesData?.closing_balance || '');
      setLedgerDetails(entriesData?.ledger_details);
      setClosingBalanceType(entriesData?.closing_balance_type);

      const ld = entriesData?.ledger_details || {};
      const isDefault = String(ld?.is_default) === '1';

      let specialRecord = {};
      // Call GetSpecialOpeningBalance ONLY for default ledgers
      if (isDefault) {
        try {
          const openingBalanceResponse = await dispatch(
            GetSpecialOpeningBalance({
              profile_id: Number(profile_id),
              ledger_id: Number(ledgerid),
            })
          ).unwrap();
          specialRecord = openingBalanceResponse?.record || {};
        } catch (innerErr) {
          // Silently fallback to ledger details if special OB not available
          console.log('GetSpecialOpeningBalance skipped/failed:', innerErr?.message);
        }
      }

      applyOpeningBalance(specialRecord, ld);
    } catch (error) {
      toast.error('No Record Found!!');
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };


  const handlePdfClick = async (e) => {
    if (e) e.preventDefault(); // Prevent default only if `e` is present

    const  {
      profile_id,
      ledger_id,
      from_date,
      to_date,
    }=item

    setIsLoading(true);

    try {
      const data=`${API_BASE_URL}${API_PATHS.ledgerpdf}/${ledger_id}/${to_date}/${from_date}/${profile_id}`

      if (data) {
        // console.log(data)
        navigate('/Pdf-Viewer', { state: { data } });
      }
    } catch (error) {
      toast.error('No Record Found!!');
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Reset Dates Functionality
  const resetDates = async () => {
    const storedFinancialYear = localStorage.getItem('selectedFinancialYear'); // Example: "2022-2023"
    
    let startYear, endYear;
    
    if (storedFinancialYear) {
      // Extract the start and end year from stored financial year
      [startYear, endYear] = storedFinancialYear.split('-');
    } else {
      // If not found, determine the current financial year dynamically
      const today = new Date();
      startYear = today.getMonth() + 1 >= 4 ? today.getFullYear() : today.getFullYear() - 1;
      endYear = parseInt(startYear) + 1;
    }
  
    const defaultFromDate = `${startYear}-04-01`;
    const defaultToDate = `${endYear}-03-31`;
  console.log(defaultFromDate,defaultToDate)
    // Update state
    setFromDate(defaultFromDate);
    setToDate(defaultToDate);
  
   localStorage.setItem('savedFromDate', defaultFromDate);
   localStorage.setItem('savedToDate', defaultToDate);

    // Update item object
    const updatedItem = {
      ...item,
      from_date: defaultFromDate,
      to_date: defaultToDate,
    };
    setItem(updatedItem);

    // Re-fetch ledger entries
    setIsLoading(true);
    try {
      const data = await dispatch(LedgerEntires(updatedItem)).unwrap();

      setLedgerEntires(data?.data?.entries || []);
      setClosingBalance(data?.data?.closing_balance || '');
      setLedgerDetails(data?.data?.ledger_details);
      setClosingBalanceType(data?.data?.closing_balance_type)
    } catch (error) {
      toast.error('No Record Found!!');
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'opening_balance') {
      const regex = /^-?\d*(\.\d{0,2})?$/;
      const sanitized = value === '-' || regex.test(value) ? value : value.slice(0, -1);

      setData((prevData) => ({
        ...prevData,
        [name]: sanitized,
      }));
      return;
    }

    setData((prevData) => ({
      ...prevData, // Spread the previous form data
      [name]: value, // Update the specific field
    }));
  };

  const applyOpeningBalance = (record = {}, fallbackLedger = {}) => {
    const rawOpening = record?.opening_balance ?? fallbackLedger?.opening_balance;
    const numeric = Number(rawOpening);
    const normalizedOpening =
      rawOpening === null || rawOpening === undefined || rawOpening === '' || Number.isNaN(numeric) || numeric === 0
        ? ''
        : String(rawOpening);

    setData((prevData) => ({
      ...prevData,
      opening_balance: normalizedOpening,
      opening_date: record?.opening_date || fallbackLedger?.opening_balance_date || '',
      dr_cr: (record?.dr_cr || fallbackLedger?.opening_balance_type || 'cr').toLowerCase(),
    }));
  };
  
  const UpdateOpeningbalance = async () => {
    // Use the latest 'data' state for the update
    const item = {
      ...data,
      profile_id: Number(profile_id),
      ledger_id: Number(ledgerid),
      dr_cr: data?.dr_cr?.toLowerCase(),
    }; // Make sure 'data' contains the latest values
    
    setIsLoading(true);
  
    try {
      const response = await dispatch(updateOpeningBalanceAll(item)).unwrap();
      
      if (response) {
        toast.success('Opening Balance Updated');
        handleLedgerClick(null, ledgerid);  // Refresh or handle the ledger click
      }
    } catch (error) {
      toast.error('No Record Found!!');
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };


  // Filter data based on search query
  const filteredledgerEntires = (ledgerEntires || [])?.filter((party) => {
    const search = searchQuery?.toLowerCase() || '';
    return (
      party?.type?.toLowerCase()?.includes(search) ||
      party?.description?.toLowerCase()?.includes(search) ||
      party?.added_on?.toLowerCase()?.includes(search) ||
      String(party?.dr || '')
        .toLowerCase()
        .includes(search) || // Safely convert to string
      String(party?.cr || '')
        .toLowerCase()
        .includes(search) || // Safely convert to string
      String(party?.balance || '')
        .toLowerCase()
        .includes(search) // Safely convert to string
    );
  });

      const handleExcelDownload = () => {
        if (!ledgerEntires || ledgerEntires.length === 0) {
            alert("No data available for download.");
            return;
        }
    
        const selectedInvoices = selectAll && ledgerEntires.length > 0
            ? ledgerEntires.map(invoice => invoice.id)
            : selectedRows;
    
        if (!selectedInvoices || selectedInvoices.length === 0) {
            alert("Please select at least one Ledger Entries.");
            return;
        }
    
        const selectedData = ledgerEntires.filter(invoice => selectedInvoices.includes(invoice.id));
    
        if (selectedData.length === 0) {
            alert("No matching Ledger Entries found.");
            return;
        }
    
        try {
          excelledgerEntriesDownload(selectedData, "ledgerEntries.xlsx");
            toast.success("Downloading Excel file successfully!");
        } catch (error) {
            console.error("Error downloading Excel file:", error);
            alert("Failed to download the Excel file. Please try again.");
        }
    };


    const handleFromDateChange = useCallback(
      (e) => {
        const newDate = e.target.value;
        if (newDate >= minDate && newDate <= maxDate) {
          setFromDate(newDate);
          localStorage.setItem("savedFromDate", newDate);
        } else {
          toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
        }
      },
      [minDate, maxDate, setFromDate]
    );
    
    const handleToDateChange = useCallback(
      (e) => {
        const newDate = e.target.value;
        if (newDate >= minDate && newDate <= maxDate) {
          setToDate(newDate);
          localStorage.setItem("savedToDate", newDate);
        } else {
          toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
        }
      },
      [minDate, maxDate, setToDate]
    );
    
    const formatFinancialYear = (startDate, endDate) => {
      return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
    };
  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 class="main-content-title tx-24 mg-b-5">Ledger</h2>
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  List
                </li>
              </ol>
            </div>
            <div class="d-flex justify-content-end">
              <a class="btn ripple btn-default" onClick={() => navigate('/addLedger')}>
                Add Ledger
              </a>
                  <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
                                                 Export Excel <FaFileExcel/>
                                                </button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="card custom-card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-4 form-inline">
                          <div class="form-group">
                            <label class="font-weight-bold">ledger Name</label>
                            <div style={{ whiteSpace: 'normal', overflowWrap: 'break-word', maxWidth: '200px' }}>{ledgerDetails?.ledger_name}</div>
                          </div>
                        </div>
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="font-weight-bold">Group Name</label>
                            <span>{ledgerDetails?.group_name}</span>
                          </div>
                        </div>
                        <div class="col-md-2 form-inline">
                          <div class="form-group">
                            <label class="font-weight-bold">State</label>
                            <span>{ledgerDetails?.state}</span>
                          </div>
                        </div>
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="font-weight-bold">GSTN</label>
                            <span>{ledgerDetails?.gstn}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          {ledgerDetails?.is_default=="1"&&ledgerDetails?.ledger_name!="Cash In Hand"&& ( <div class="card custom-card mt-4">
                <div class="card-body">
                  <div className="row align-content-center">
                    <div className="col-md-4 ">
                      <div className="form-group">
                        <label className="mb-2 font-weight-bold">Date</label>
                        <input name="opening_date" className="form-control" type="date" value={data?.opening_date} onChange={handleInputChange} />
                      </div>
                    </div>
                    <div className="col-md-4 ">
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="col-black mb-2 font-weight-bold" > Opening Balance</label>
                        <div className="ml-2">
                          <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio"  name="dr_cr" id="credit" value="cr" checked={data?.dr_cr == 'cr'} onChange={handleInputChange} />
                            <label className="form-check-label" htmlFor="credit">
                              Cr
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio"  id="debit" value="dr"  name="dr_cr" checked={data?.dr_cr == 'dr'} onChange={handleInputChange}/>
                            <label className="form-check-label" htmlFor="debit">
                              Dr
                            </label>
                          </div>
                        </div>
                      </div>
                      <input name="opening_balance" type="text" className="form-control" placeholder="Enter the amount" value={data?.opening_balance} onChange={handleInputChange} />
                    </div>
                    <div className="col-md-4 d-flex align-items-center mt-4">
                      <div className="form-group">
                        <button type="submit" className="btn btn-default" onClick={UpdateOpeningbalance}>
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}

              <div className="row mt-3">
                <div className="col-md-12">
                  <div class="row mt-3">
                    <div class="col-md-12">
                      <Table
                        columns={columns}
                        data={filteredledgerEntires}
                        tableRef={tableRef}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        currentPage={currentPage}
                        totalCount={filteredledgerEntires?.length}
                        onPageChange={handlePageChange}
                        handleSearchChange={handleSearchChange}
                        closing_balance={closingBalance}
                        closingBalanceType={closingBalanceType}
                        showDateFilters={showDateFilters}
                        fromDate={fromDate}
                        toDate={toDate}
                        setFromDate={handleFromDateChange}
                        setToDate={handleToDateChange}
                        resetDates={resetDates}
                        handleSubmit={handleLedgerClick}
                        handleSubmitPdf={handlePdfClick}
                        selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows} 
                    selectAll={selectAll} 
                     setSelectAll={setSelectAll} 
                     minDate={minDate}
                     maxDate={maxDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default LedgerDetails;
